
export default {
  name: 'PagesAboutExtentionsForm',
  props: {
    source: {
      type: Object,
      default: () => {
        return {
          position: 'Форма "Поможем в выборе"',
          chapter: 'Страница "О нас | Расширения"',
        }
      },
    },
  },

  data() {
    return {
      isSend: false,
      userName: this.accountName(),
      userEmail: this.$auth.user?.email ? this.$auth.user.email : null,
      userPhone: this.$auth.user?.phone ? this.$auth.user.phone : null,

      lead: {
        data: {
          title: 'Пользователь просит помощи',
          to: 'forbusiness',
          type: 'CALL',
          level: 'BUSINESS',
          body: null,
          source: { ...this.source, source: this.$route.path },
        },
      },
    }
  },

  computed: {
    isValid() {
      return this.userName && this.userEmail && this.userPhone
    },
  },

  methods: {
    accountName() {
      if (this.$auth.loggedIn) {
        if (this.$auth.user.type === 'COMPANY') {
          return this.$auth.user.company?.title
            ? this.$auth.user.company?.title
            : this.$auth.user.username
        } else {
          return this.$auth.user.profile?.firstName &&
            this.$auth.user.profile?.lastName
            ? `${this.$auth.user.profile.firstName} ${this.$auth.user.profile.lastName}`
            : this.$auth.user.username
        }
      }
      return null
    },
    async sendLead() {
      const lead = {
        ...this.lead.data,
        from: {
          username: this.$auth.user?.username ? this.$auth.user.username : null,
          name: this.userName,
          email: this.userEmail,
          phone: this.userPhone,
          roles: this.$auth.user?.roles ? this.$auth.user.roles : null,
        },
      }

      try {
        this.isSend = false
        await this.$axios.$post('/lead/send', lead)
        this.isSend = true
      } catch (error) {
        this.isSend = false
        console.log(error)
      }
    },
  },
}
